import { CredentialType } from "@/domain/credentials.model";
import { Options, Vue } from "vue-class-component";
import Logout from "./logout/logout.vue";
import Menu from "./menu/menu.vue";

@Options({
  components: {
    "user-logout": Logout,
    "menu-header": Menu,
  },
})
export default class Header extends Vue {
  private headerElement: HTMLElement | null = null;

  public async mounted(): Promise<void> {
    this.headerElement = document.getElementById("main-header") as HTMLElement;
  }

  public onToggleMenuSidebar(): void {
    this.$store.dispatch("ui/toggleMenuSidebar");
  }

  public onToggleControlSidebar(): void {
    this.$store.dispatch("ui/toggleControlSidebar");
  }

  get darkModeSelected() {
    return this.$store.getters["ui/darkModeSelected"];
  }

  get navbarVariant() {
    return this.$store.getters["ui/navbarVariant"];
  }

  get isMasterUser() {
    return this.$store.getters["auth/type"] === CredentialType.MASTER;
  }
}
